import React from "react";
import styles from "./LoadingSoup.module.css"; // Importamos los estilos usando CSS Modules

const LoadingSoup = () => {
  return (
    <div className={styles.loadingSoupContainer}>
      <div className={styles.soupBowl}>
        <div className={styles.steam}></div>
      </div>
      <p className={styles.loadingText}>Creando Kit...</p>
    </div>
  );
};

export default LoadingSoup;
